/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserConfig } from "../models/UserConfig";
import type { UserConfigCreate } from "../models/UserConfigCreate";
import type { UserConfigUpdate } from "../models/UserConfigUpdate";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class UserConfigService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get User Config
   * ユーザー設定を取得
   * @returns UserConfig Successful Response
   * @throws ApiError
   */
  public getUserConfig({ userId }: { userId: string }): CancelablePromise<UserConfig> {
    return this.httpRequest.request({
      method: "GET",
      url: "/configs/{user_id}",
      path: {
        user_id: userId
      },
      errors: {
        422: `Validation Error`
      }
    });
  }

  /**
   * Update User Config
   * ユーザー設定を更新
   * @returns UserConfig Successful Response
   * @throws ApiError
   */
  public updateUserConfig({
    userId,
    requestBody
  }: {
    userId: string;
    requestBody: UserConfigUpdate;
  }): CancelablePromise<UserConfig> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/configs/{user_id}",
      path: {
        user_id: userId
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`
      }
    });
  }

  /**
   * Delete User Config
   * ユーザー設定を削除
   * @returns any Successful Response
   * @throws ApiError
   */
  public deleteUserConfig({ userId }: { userId: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/configs/{user_id}",
      path: {
        user_id: userId
      },
      errors: {
        422: `Validation Error`
      }
    });
  }

  /**
   * Create User Config
   * ユーザー設定を作成
   * @returns UserConfig Successful Response
   * @throws ApiError
   */
  public createUserConfig({
    requestBody
  }: {
    requestBody: UserConfigCreate;
  }): CancelablePromise<UserConfig> {
    return this.httpRequest.request({
      method: "POST",
      url: "/configs",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`
      }
    });
  }
}
